import { PageTitle } from 'presentation/components/PageTitle';
import SimulateDesc from 'presentation/components/SimulateDesc';
import React, { useState } from 'react';
import FormSimulateSale from './components/FormSimulateSale';

import { Form } from 'antd';
import { SimulateUseCaseInterface } from 'application/usecases/SimulateUseCase';
import DropdownIcon from 'assets/icons/simulate_dropdown.svg';
import DropupIcon from 'assets/icons/simulate_dropup.svg';
import { OptionEntity } from 'domain/entities/OptionEntity';
import {
    SimHistoryInfo,
    SimulateCashFlowEntity,
    SimulateCashFlowGetEntity,
    SimulateLoanFinancialEntity,
} from 'domain/entities/SimulateEntity';
import { SCREEN_NAME } from 'infrastructure/config/CONSTANTS';
import { openErrorNoti, openSuccessNoti } from 'presentation/components/Notification';
import {
    completeFetching,
    showConfirm,
    startFetching,
} from 'presentation/redux/features/app/appSlice';
import { useAppDispatch, useAppSelector } from 'presentation/redux/hooks';
import { AUTH_ROUTES } from 'presentation/router/CONSTANTS';
import { useCollapse } from 'react-collapsed';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import getMessage from 'utilities/constants/MESSAGE';
import { commonHelpers } from 'utilities/helpers';
import { SimHistoryModal } from '../CU-010-02/components/SimHistoryModal';
import { SimInputTitleModal } from '../CU-010-02/components/SimInputTitleModal';
import { descView } from './models/desc';

type props = {
    simualteUseCase: SimulateUseCaseInterface;
};

const OPTION_YEAR = Array.from(Array(26).keys()).map((item) => {
    const i = item + 10;
    return {
        value: `${i}`,
        label: `${i}年`,
    };
});

const CU05102Page = ({ simualteUseCase }: props) => {
    const [form] = Form.useForm();
    const { simId } = useParams();
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const userSlice = useAppSelector((state) => state.user);

    const [desc, setDesc] = React.useState<any[]>([]);
    const [loanFinancial, setLoanFinancial] = React.useState<OptionEntity[]>([]);
    const [loanFinancialSelected, setLoanFinancialSelected] = useState<any>();
    const [loanRefer, setLoanRefer] = React.useState<any[]>([]);
    const [data, setData] = useState<SimulateCashFlowGetEntity>();
    const [masterFee, setMasterFee] = useState<any>();
    const [isDisalbleItem, setDisalbleItem] = useState<boolean>(true);
    const [historyList, setHistoryList] = React.useState<SimHistoryInfo[]>();
    const [openSimHistoryModal, setOpenSimHistoryModal] = React.useState<boolean>(false);
    const [openSimInputTitleModal, setOpenSimInputTitleModal] = React.useState<boolean>(false);
    const [selectedHistorySimId, setSelectedHistorySimId] = React.useState<number>();
    const [savePayload, setSavePayload] = React.useState<SimulateCashFlowEntity>();
    const [btnDisable, setBtnDisable] = React.useState<boolean>(false);

    const getLoanFinancial = async () => {
        try {
            const responses = await Promise.all([
                simualteUseCase.getSimulateLoadFinancial(),
                simualteUseCase.getMasterFee(),
            ]);
            const [response, master] = responses;
            setMasterFee(master.result);
            const options: OptionEntity[] = [];
            response.results.forEach((item: SimulateLoanFinancialEntity) => {
                options.push({
                    value: `${item.loanFinancialInstitutionCode}`,
                    label: item.financialInstitutionNameDisp,
                });
            });
            setLoanFinancial(options);
            setLoanRefer(response.results);
        } catch (error: any) {
            openErrorNoti();
        }
    };

    const getData = async (values: SimulateCashFlowEntity) => {
        try {
            dispatch(startFetching());
            const payload = {
                ...values,
                simId: values.simId ?? null,
            };
            const response = await simualteUseCase.getSimulateCashFlow(payload);
            const data = response.result;
            setData(data);
            setDesc(
                descView([
                    {
                        center: commonHelpers.formatNumberMoney(data.monthlyBalanceOfPayments),
                        right: commonHelpers.formatNumberMoney(data.monthlyBalanceOfPayments * 12),
                    },
                    {
                        center: commonHelpers.formatNumberMoney(data.loanAmount),
                        right: '3,667', // TODO: lấy thông tin từ api trả ra (APIから返された情報を取得する)
                    },
                    {
                        center: commonHelpers.formatNumberMoney(data.monthlyPaymentAmount),
                        right: commonHelpers.formatNumberMoney(data.totalManagementFee),
                    },
                    {
                        center: commonHelpers.formatNumberMoney(data.rentalIncome),
                        right: commonHelpers.formatNumberMoney(data.commonServiceFee),
                    },
                ]),
            );
            // init form value
            form.setFieldsValue({
                purchasePrice: commonHelpers.formatNumberMoney(data.purchasePrice),
                personalFunds: commonHelpers.formatNumberMoney(Number(data.personalFunds)),
                repaymentPeriod: commonHelpers.formatNumberMoney(data.repaymentPeriod),
                rent: commonHelpers.formatNumberMoney(data.rent),
                commonServiceFee: commonHelpers.formatNumberMoney(data.commonServiceFee),
                managementFee: commonHelpers.formatNumberMoney(data.managementFee),
                reserveFundForRepairs: commonHelpers.formatNumberMoney(data.reserveFundForRepairs),
                loanFinancialInstitutionCode: data.loanFinancialInstitutionCode,
                interestRate: Number(data.interestRate),
                buildingAge: commonHelpers.formatNumberMoney(data.buildingAge),
                expense: commonHelpers.formatNumberMoney(data.expense),
                otherExpenses: commonHelpers.formatNumberMoney(data.otherExpenses),
                title: data.simulationTitle ?? '',
                includeBrokerageFee: data.includeBrokerageFee,
            });
            if (data.loanFinancialInstitutionCode == 'manual_settings') {
                setDisalbleItem(false);
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const onChangeSelect = (value: string) => {
        const destination: any = loanRefer.find(
            (item: any) => item.loanFinancialInstitutionCode === value,
        );
        if (value == 'manual_settings') {
            setDisalbleItem(false);
        } else {
            setDisalbleItem(true);
        }
        setLoanFinancialSelected(destination);
        form.setFieldsValue({
            interestRate: Number(destination.interestRateLowerLimit),
            buildingAge: Number(destination.buildingAgeCriteria),
            expense: commonHelpers.formatNumberMoney(Number(destination.expenseLowerLimit)),
        });
    };

    React.useEffect(() => {
        getLoanFinancial();
        const payload = {
            ...location.state,
            simId: Number(simId) ?? null,
        };
        getData(payload);
    }, []);

    const checkLogin = async (values: SimulateCashFlowEntity) => {
        if (userSlice?.isSignedIn) {
            if (simId) {
                setSavePayload(values);
                saveData(form.getFieldValue('title'), values);
            } else {
                openHistoryPopup(values);
                setSavePayload(values);
            }
        } else {
            const confirmProps = {
                message: '以降のステップには\nログインが必要です。',
                okText: 'ログイン・アカウント作成へ',
                cancelText: 'いいえ',
                type: 'info',
                onOk: goToLoginPage,
            };
            dispatch(showConfirm(confirmProps));
        }
    };

    const goToLoginPage = () => {
        navigate(`${AUTH_ROUTES.PATH}/${AUTH_ROUTES.SUB.CU_001_00}`);
    };

    const openHistoryPopup = async (values: SimulateCashFlowEntity) => {
        try {
            dispatch(startFetching());
            const payload: SimulateCashFlowEntity = {
                ...values,
            };
            const responses = await Promise.all([
                simualteUseCase.getSimModalList('CU-051-02'),
                getData(payload),
            ]);
            const response = responses[0];
            if (response.result) {
                setHistoryList(response.result.listSim);
            }
            // eslint-disable-next-line no-empty
        } catch (err) {
        } finally {
            dispatch(completeFetching());
        }
    };

    React.useEffect(() => {
        if (historyList) {
            if (historyList.length >= 10) {
                setOpenSimHistoryModal(true);
            } else {
                openInputPopup();
            }
        }
    }, [historyList]);

    const openInputPopup = async (simId?: number) => {
        setSelectedHistorySimId(simId);
        setHistoryList(undefined);
        setOpenSimHistoryModal(false);
        setOpenSimInputTitleModal(true);
    };

    const saveData = async (title: string, payloadDirect?: SimulateCashFlowEntity) => {
        setOpenSimInputTitleModal(false);
        const payload = {
            ...savePayload,
            ...payloadDirect,
            simId: simId ? Number(simId) : selectedHistorySimId ?? null,
            title: title,
            simulationTitle: title,
        };
        try {
            dispatch(startFetching());
            await simualteUseCase.createSimulateCashFlow(payload);
            setBtnDisable(true);
            openSuccessNoti({ description: getMessage('S338') });
            // eslint-disable-next-line no-empty
        } catch (error: any) {
        } finally {
            dispatch(completeFetching());
        }
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-051-02-container"
        >
            <PageTitle title={SCREEN_NAME['CU-051-02']} />
            <section
                style={{
                    padding: '10px 0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: 60,
                    overflowX: 'hidden',
                }}
            >
                <div className="content" id="top-page">
                    <SimulateDesc lines={desc} />
                    <div className="content-collapse">
                        <div className="content-collapse__title">入力条件</div>
                        <div className="content-collapse__icon" {...getToggleProps()}>
                            <img src={isExpanded ? DropupIcon : DropdownIcon} alt="dropdown icon" />
                        </div>
                    </div>
                    <FormSimulateSale
                        options={OPTION_YEAR}
                        form={form}
                        loanOption={loanFinancial}
                        onChangeSelect={onChangeSelect}
                        feeRate={masterFee?.feeRate}
                        fixedFeeAmount={masterFee?.fixedFeeAmount}
                        loanFinancialSelected={loanFinancialSelected}
                        isDisalbleItem={isDisalbleItem}
                        getData={getData}
                        getCollapseProps={getCollapseProps}
                        onSave={checkLogin}
                        btnDisable={btnDisable}
                        setBtnDisable={setBtnDisable}
                        data={data}
                        loanRefer={loanRefer}
                    />
                </div>
                <SimHistoryModal
                    data={historyList}
                    open={openSimHistoryModal}
                    onOk={openInputPopup}
                    onCancel={() => {
                        setHistoryList(undefined);
                        setOpenSimHistoryModal(false);
                    }}
                />
                <SimInputTitleModal
                    open={openSimInputTitleModal}
                    onOk={saveData}
                    onCancel={() => {
                        setHistoryList(undefined);
                        setOpenSimInputTitleModal(false);
                    }}
                />
            </section>
        </div>
    );
};

export default CU05102Page;
